import { TFunction } from 'i18next';
import { ConferenceParty } from '../../types';

function getFirstName(name: string): string {
  const parts = name.split(' ');
  return parts[0] || name;
}

export function formatParticipantsSummary(parties: ConferenceParty[], t: TFunction): string {
  if (parties.length === 0) {
    return '';
  }

  if (parties.length === 1) {
    return t('call:participants.isInConference', { name: getFirstName(parties[0].name) });
  }

  if (parties.length === 2) {
    return t('call:participants.twoInConference', {
      name1: getFirstName(parties[0].name),
      name2: getFirstName(parties[1].name),
    });
  }

  const othersCount = parties.length - 2;
  return t('call:participants.manyInConference', {
    name1: getFirstName(parties[0].name),
    name2: getFirstName(parties[1].name),
    count: othersCount,
  });
}
